import { List } from 'antd';
import { TabPaneContainer } from '../styles';
import { Cause, QueryType, Routine } from '../../../../types';
import ToBeReviewItem from '../../../../components/toBeReviewItem';
import { useAppDispatch } from '../../../../store';
import { useRef, useState } from 'react';
import { fetchNotifications } from '../../../../slices/notifications';
import ReviewRoutineDrawer from '../../../../components/reviewRoutineDrawer';

const Routines = ({ routines }: { routines: Routine[] }) => {
  const dispatch = useAppDispatch();
  const [showReviewDrawer, setShowReviewDrawer] = useState(false);
  const currentItem = useRef<Routine>(null);

  const handleReviewDrawerClose = (isSubmitted?: boolean) => {
    setShowReviewDrawer(false);
    if (isSubmitted) {
      dispatch(fetchNotifications());
    }
  };
  return (
    <TabPaneContainer>
      <List
        pagination={false}
        dataSource={routines}
        renderItem={(item, index) => (
          <ToBeReviewItem
            name={item.templateName}
            description={item.name}
            onClick={() => {
              setShowReviewDrawer(true);
              currentItem.current = item;
            }}
          />
        )}
        // footer={
        //   routines?.length > 3 ? (
        //     <Flex align="center" justify="center">
        //       <Button type="text">Load more</Button>
        //     </Flex>
        //   ) : null
        // }
      />
      {currentItem.current && (
        <ReviewRoutineDrawer
          visible={showReviewDrawer}
          onClose={handleReviewDrawerClose}
          data={currentItem.current}
        />
      )}
    </TabPaneContainer>
  );
};

export default Routines;
